import * as React from "react";
import "./category.less";
import { CategoryItem } from "./category-item";
import { IProductCategoryModel } from "states/menu/menu.models";
export interface ICategoryProps {
  categories: IProductCategoryModel[]
}
export function Categories(props: ICategoryProps) {
  const { categories } = props;

  return <ul id="menu-list" className="space-y-4">
    {categories?.map((cate) => (<CategoryItem key={cate.id} model={cate} />))}
  </ul>;
}
